<template>
	<div class="field">
		<label for="tariff">Tarif:</label>
		<select @change="selectTariff" v-model="selectedTariffId" name="tariff" id="tariff">
			<option v-for="tariff in tariffs" :key="tariff.id" :value="tariff.id">{{ tariff.name }}</option>
		</select>
	</div>
</template>

<script>
export default {
	data() {
		return {
			tariffs: this.$store.getters.getTariffs,
			selectedTariffId: this.$store.getters.getSelectedTariffId
		}
	},
	methods: {
		selectTariff() {
			this.$store.commit('setTariff', {id: this.selectedTariffId})
			this.$store.dispatch('updatePrices');
		}
	}
}
</script>
